import React from 'react';
import {StaticImage} from "gatsby-plugin-image";
import {Link} from "gatsby";

function MineEventDescription(props) {
    return (
        <>
            <div className="about-wrapper pt--120">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 text-center text-lg-left">
                            <div className="">
                                <div className="section-title">
                                    <h2 className="title">Magical Litija and the Sitarjevec mine</h2>
                                    <p className="description">
                                        As part of the December events in Litija, which we named Magic Litija, there is also a wide area of events in and before the Sitarjevec mine. Events are well attended and attract more and more visitors every year. They are inviting the visitors with differentness and uniqueness, and some with nostalgia and a pleasant atmosphere.
                                    </p>
                                    <div className="mt--30">
                                        <Link to="/en#news" className="btn-default size-md">CURRENT EVENTS</Link>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-xl-6 mt-4 ">
                            <div className="thumbnail">
                                <StaticImage
                                    alt="Magical Litija and the Sitarjevec mine"
                                    src="../../../assets/images/rudnik/december-rudnik-sitarjevec.jpeg"
                                    placeholder="blurred"
                                    imgClassName="img-fluid w-100"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-wrapper pt--60 pb--120 bg_color--1">
                <div className="container">
                    <div className="row align-items-center text-center text-lg-left">
                        <div className="col-lg-6 col-md-12 order-1 order-lg-0 mt-4">
                            <div className="thumbnail">
                                <StaticImage
                                    src="../../../assets/images/rudnik/pohod-z-baklami.jpeg"
                                    alt="Torchlight procession in Litija in December"
                                    placeholder="blurred"
                                    imgClassName="img-fluid w-100"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-xl-6 order-0 order-lg-1">
                            <div className="">
                                <div className="section-title">
                                    <h2 className="title">Torchlight procession</h2>
                                    <p className="description">
                                        The traditional hike on the name day of St. Barbara, December the 4th. When thousands of lights are lit in Litija dwarfs and Litko greet the hikers. They start the procession from the old town and continue to the mine with lit torches.
                                    </p>
                                    <div className="mt--30">
                                        <Link to="/en#news" className="btn-default size-md">CURRENT EVENTS</Link>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default MineEventDescription;